export default {
    namespaced: true,

    state: {
        token: null,
        user: {},
        practice: {},
        members: [],
        userLocations: [],
        lastRegisteredPhysician: null,
        facilityServicesByLocation: [],
        pendingReferralAction: { made: [], received: [] },
        insurancePlans: [],
        sessionHydrated: false,
    },

    getters: {
        getToken(state) {
            return state.token
        },

        getUser(state) {
            return state.user
        },

        getPractice(state) {
            return state.practice
        },

        getMembers(state) {
            return state.members
        },

        getLastRegisteredPhysician(state) {
            return state.lastRegisteredPhysician
        },

        getUserLocations(state) {
            return state.userLocations
        },

        getFacilityServicesByLocation(state) {
            return state.facilityServicesByLocation
        },

        getPendingReferralAction(state) {
            return state.pendingReferralAction
        },

        getInsurancePlans(state) {
            return state.insurancePlans
        },

        isSessionHydrated(state) {
            return state.sessionHydrated
        },
    },

    mutations: {
        setToken(state, token) {
            state.token = token
        },

        setUser(state, user) {
            state.user = user
        },

        setPractice(state, practice) {
            state.practice = practice
        },

        setMembers(state, members) {
            state.members = members
        },

        setLastRegisteredPhysician(state, physician) {
            state.lastRegisteredPhysician = physician
        },

        setUserLocations(state, locations) {
            state.userLocations = locations
        },

        setFacilityServicesByLocation(state, facilityServicesByLocation) {
            state.facilityServicesByLocation = facilityServicesByLocation
        },

        setPendingReferralActionMade(state, pendingReferralAction) {
            state.pendingReferralAction.made = pendingReferralAction
        },
        setPendingReferralActionReceived(state, pendingReferralAction) {
            state.pendingReferralAction.received = pendingReferralAction
        },

        setInsurancePlans(state, insurancePlans) {
            state.insurancePlans = insurancePlans
        },

        setSessionHydrated(state, sessionHydrated) {
            state.sessionHydrated = sessionHydrated
        },

        clearInsurancePlans(state) {
            state.insurancePlans = []
        },

        clearSessionHydrated(state) {
            state.sessionHydrated = false
        },

        clearToken(state) {
            state.token = null
        },

        clearUser(state) {
            state.user = {}
        },

        clearPractice(state) {
            state.practice = {}
        },

        clearMembers(state) {
            state.members = []
        },

        clearLastRegisteredPhysician(state) {
            state.lastRegisteredPhysician = null
        },

        clearUserLocations(state) {
            state.userLocations = []
        },

        clearFacilityServicesByLocation(state) {
            state.facilityServicesByLocation = []
        },

        clearPendingReferralAction(state) {
            state.pendingReferralAction = {}
        },
    },

    actions: {
        setToken(Store, token) {
            Store.commit('setToken', token)
        },

        setUser(Store, user) {
            Store.commit('setUser', user)
        },

        setPractice(Store, practice) {
            Store.commit('setPractice', practice)
        },

        setMembers(Store, members) {
            Store.commit('setMembers', members)
        },

        setLastRegisteredPhysician(Store, physician) {
            Store.commit('setLastRegisteredPhysician', physician)
        },

        setUserLocations(Store, locations) {
            Store.commit('setUserLocations', locations)
        },

        setFacilityServicesByLocation(Store, facilityServicesByLocation) {
            Store.commit('setFacilityServicesByLocation', facilityServicesByLocation)
        },

        setPendingReferralActionMade(Store, pendingReferralAction) {
            Store.commit('setPendingReferralActionMade', pendingReferralAction)
        },

        setPendingReferralActionReceived(Store, pendingReferralAction) {
            Store.commit('setPendingReferralActionReceived', pendingReferralAction)
        },

        setInsurancePlans(Store, insurancePlans) {
            Store.commit('setInsurancePlans', insurancePlans)
        },

        setSessionHydrated(Store, sessionHydrated) {
            Store.commit('setSessionHydrated', sessionHydrated)
        },

        clear(Store) {
            Store.commit('clearToken')
            Store.commit('clearUser')
            Store.commit('clearPractice')
            Store.commit('clearMembers')
            Store.commit('clearLastRegisteredPhysician')
            Store.commit('clearUserLocations')
            Store.commit('clearFacilityServicesByLocation')
            Store.commit('clearPendingReferralAction')
            Store.commit('clearInsurancePlans')
            Store.commit('clearSessionHydrated')
        },
    },
}
